import React from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import DahboardAnimation from "@components/ui/animations/dashboardNew.json";
import DietPlan from "@components/ui/animations/DietPlan.json";
import Exercise from "@components/ui/animations/Exercise.json";
import SleepCoach from "@components/ui/animations/sleep coach.json";
import Mindfulness from "@components/ui/animations/mindfulness.json";
import Preferences from "@components/ui/animations/preferences.json";
import Fitbot from "@components/ui/animations/fitbot.json";
import Advise from "@components/ui/animations/advise me.json";
import QuizGame from "@components/ui/animations/Questions.json";
import WeeklyTracker from "@components/ui/animations/Weekly progress tracker.json";
import ProgressTracker from "@components/ui/animations/speedoMeter.json";


import { useTranslation } from "react-i18next";
const ActualDietPlanLoader = ({
  dashboard = false,
  exercisePlan = false,
  sleepCoach = false,
  mindfulness = false,
  adviseMe = false,
  fitbot = false,
  preferences = false,
  quizGame = false,
  weeklyTracker = false,
  progressTracker=false

}) => {
  const { t } = useTranslation();

  const animations = [
    { condition: dashboard, src: DahboardAnimation },
    { condition: exercisePlan, src: Exercise },
    { condition: sleepCoach, src: SleepCoach },
    { condition: mindfulness, src: Mindfulness },
    { condition: adviseMe, src: Advise },
    { condition: fitbot, src: Fitbot },
    { condition: preferences, src: Preferences },
    { condition: quizGame, src: QuizGame },
    { condition: weeklyTracker, src: WeeklyTracker },
    { condition: progressTracker, src: ProgressTracker },
  ];

  // find the first true condition, otherwise fallback to DietPlan
  const animation = animations.find((a) => a.condition)?.src || DietPlan;
  return (
    <div className="w-full bg-white flex item-center justify-center flex-col h-[80vh] ">
      <Player
        autoplay
        loop
        src={animation}
        style={{ height: "300px", width: "300px" }}
      ></Player>
      <div className="flex items-center justify-center gap-2">
        <h2 className="text-[24px] font-[Lato] font-[600] text-center">
          {t(`loader.waitintText`)}
        </h2>
        <div className="flex items-center justify-center">
          <div class="mask">
            <div class="loader">
              <div class="loader__bounce first !bg-black !w-3 !h-3"></div>
              <div class="loader__bounce second !bg-black !w-3 !h-3"></div>
              <div class="loader__bounce third !bg-black !w-3 !h-3"></div>
            </div>
          </div>
        </div>
      </div>

      {/* <p className="text-center text-[#535862] font-[400] mt-3">
        {exercisePlan
          ? "Building your custom workout plan... get ready to break a sweat!"
          : "Calculating your personalized path to a healthier you... hang tight!"}
      </p> */}
    </div>
  );
};

export default ActualDietPlanLoader;
